import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export const KanbanCardTag = (props) => {
    var _a, _b;
    return (_jsxs("span", { className: `je-kanban-card-tag 
      ${(_a = props.icon.props.className) !== null && _a !== void 0 ? _a : "fc-sc-green"}
      `, children: [_jsx("span", { className: "je-kanban-card-tag icon", children: props.icon }), _jsx("span", { className: `je-kanban-card-tag text ${(_b = props.textClassName) !== null && _b !== void 0 ? _b : "fc-sc-black"}`, children: props.text })] }));
};
